<template>
    <div>
        <h1>{{ $t("calculations.heading") }}</h1>
        <table class="table">
            <tr>
                <th>{{ $t("calculations.createdAt") }}</th>
                <th>{{ $t("calculations.createdBy") }}</th>
                <th>{{ $t("calculations.modifiedBy") }}</th>
                <th>{{ $t("utils.actions") }}</th>
            </tr>
            <tr v-for="(calculation, i) in calculations">
                <td>{{ calculation.created_at }}</td>
                <td>{{ calculation.created_by.name }}</td>
                <td>{{ calculation.modified_by.name }}</td>
                <td>
                    <router-link :to="{ name: 'calculationEdit', params: {slug: calculation.slug} }" class="btn btn-primary me-2">{{ $t("utils.edit") }}</router-link>
                    <router-link :to="{ name: 'calculation', params: {slug: calculation.slug} }" class="btn btn-primary me-2">{{ $t("utils.detail") }}</router-link>
                    <button class="btn btn-primary" @click="hide(calculation.slug)">{{ $t("utils.delete") }}</button>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
export default {
    data() {
        return {
            calculations: [],
            loading: false
        }
    },
    created: function () {
        this.loadData();
    },
    methods: {
        loadData: function () {
            this.loading = true;
            this.$store.getters.api.get("/calculations").then(function (response) {
                this.calculations = response.data.data;
                this.loading = false;
            }.bind(this))
        },
        hide: function (id) {
            this.$store.getters.api.post("/calculation/" + id +"/hide").then(function (response) {
                this.loadData();
            }.bind(this))
        }
    }
}
</script>
<style lang="scss">
</style>